import { HttpClient } from '@angular/common/http';
import { Gt2ApiService } from './gt2-api.service';
import { ApiRoutes } from './ApiRoutes';
import { Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';

@Injectable({
  providedIn: 'root',
})
export class ExternalEnvService {
  constructor(
    private http: HttpClient,
    private logger: NGXLogger,
    private api: Gt2ApiService,
  ) {}

  public getEnv(): any {
    //this.logger.info("ExternalEnvService.getEnv()");

    return this.http.get<any>(this.api.createUrl(ApiRoutes.EXT_ENV));
  }
}
